import { z } from 'zod'

import { DateZod, GeoPointZod, GoogleDistanceMatrixElementZod } from '../common'

export const DistanceZod = z.object({
  value: GoogleDistanceMatrixElementZod.or(z.literal('unavailable')),
  transportRequestId: z.string(),
  teamId: z.string(),
  assignmentId: z.string().optional(),
  teamCurrentTransportRequestId: z.string().optional(),
  timestamp: DateZod,
  deleteAt: DateZod.optional(),
  origin: GeoPointZod,
  destination: GeoPointZod,
  requestedBy: z.string().optional(),
  linearDistance: z
    .object({
      haversine: z.number(),
      durationConversionFactor: z.number(),
    })
    .optional(),
})
